import { InputErrorMessage as Error, FormInput, Text } from '@/components';
import APP_CONFIG from '@/config/app';
import { ErrorMessage } from '@hookform/error-message';
import { AnimatePresence } from 'framer-motion';
import { FC } from 'react';
import { FieldErrors, UseFormClearErrors } from 'react-hook-form';
const {
  MAIN_BACKDROP_BLUR,
  MAIN_ROUNDEDNESS,
  MAIN_PADDING,
  WHOLESTEP_DECREMENT,
} = APP_CONFIG.STYLES;
interface RatingTextInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
  errors: FieldErrors;
  clearErrors?: UseFormClearErrors<any>;
  showError?: boolean;
  className?: string;
  label?: string;
  placeholder?: string;
  multiLine?: boolean;
  noOfLines?: number;
}
const RatingTextInput: FC<RatingTextInputProps> = ({
  value,
  onChange,
  name,
  errors,
  clearErrors,
  showError,
  className = '',
  label,
  placeholder,
  multiLine = false,
  noOfLines = 3,
}) => {
  const errorMessage = errors[name];
  const hasError = !!(errors && errorMessage);
  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onChange(e.target.value);
  };
  const handleOnBlur = () => {
    if (hasError && clearErrors) {
      clearErrors(name);
    }
  };
  return (
    <div className={`flex flex-col gap-2 w-full ${className}`}>
      {label && <Text value={label} color={'secondary'} />}
      <div className={hasError ? 'bg-error/15 flex rounded-t-2xs' : 'flex'}>
        {multiLine ? (
          <div className="w-full bg-primary/5 border border-primary/5 hover:bg-primary/10 hover:border-primary/10 focus-within:bg-primary/15 focus-within:border-primary/15 active:bg-primary/15 active:border-primary/15 rounded-2xs">
            <textarea
              name={name}
              value={value}
              onChange={handleOnChange}
              onBlur={handleOnBlur}
              placeholder={placeholder}
              rows={noOfLines}
              className={`w-full p${MAIN_PADDING} bg-transparent border-none text-primary placeholder:text-primary/50 text-md focus:outline-none focus:ring-0 resize-none appearance-none block rounded${MAIN_ROUNDEDNESS}`}
            />
          </div>
        ) : (
          <FormInput
            name={name}
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            errors={errors}
            clearErrors={clearErrors}
            showError={false}
            placeholder={placeholder}
            type="text"
            className="w-full"
          />
        )}
      </div>
      <ErrorMessage
        errors={errors}
        name={name as any}
        render={({ message }) =>
          message && showError ? (
            <AnimatePresence>
              <Error
                message={message}
                className={`relative bottom-0.5 left-0 right-0 backdrop-blur${MAIN_BACKDROP_BLUR}`}
              />
            </AnimatePresence>
          ) : null
        }
      />
    </div>
  );
};
export default RatingTextInput;
